import { Dispatch, ReactElement, SetStateAction, useMemo } from "react";

import { CSSObject } from "@emotion/react";
import {
  Button,
  ChevronLeftSVG,
  ChevronRightSVG,
  Icon,
  SvgComponentType,
} from "@newsela/angelou";

import {
  IAbsolutePosition,
  NavButtonWithPopout,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/NavButtonWithPopout/NavButtonWithPopout";
import {
  getNavMenuButtonAriaProps,
  IButtonAriaProps,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/NavButtonWithPopout/NavButtonWithPopout.utils";
import {
  buttonCss,
  chevronLeftCss,
  chevronRightCss,
  openedSubMenuPopoutIndicatorCss,
  popoutButtonListItemCss,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/PopoutSectionItemWithPopout/PopoutSectionItemWithPopout.styles";

const PopoutSectionItemWithPopout = ({
  id,
  isOpen,
  setIsOpen,
  position,
  buttonText,
  rootCustomCss = {},
  PopoutComponent,
}: IPopoutMenuItemWithPopout) => {
  const buttonAriaProps: IButtonAriaProps = useMemo(
    () =>
      getNavMenuButtonAriaProps({
        id,
        isOpen,
      }),
    [isOpen],
  );

  return (
    <NavButtonWithPopout
      id={id}
      isSubNavMenu
      isOpen={isOpen}
      rootCustomCss={rootCustomCss}
      setIsOpen={setIsOpen}
      position={position}
      ButtonComponent={
        <div css={popoutButtonListItemCss}>
          <Button
            __cssFor={buttonCss}
            ariaProps={buttonAriaProps}
            flavor={Button.flavors.incognito}
            onClick={() => setIsOpen((isOpen) => !isOpen)}
          >
            {isOpen && <div css={openedSubMenuPopoutIndicatorCss} />}
            <Icon
              SvgComponent={ChevronLeftSVG as SvgComponentType}
              __cssFor={chevronLeftCss}
              __classNameFor={{ root: id }}
            />

            {buttonText}

            <Icon
              SvgComponent={ChevronRightSVG as SvgComponentType}
              __cssFor={chevronRightCss}
              __classNameFor={{ root: id }}
            />
          </Button>
        </div>
      }
      PopoutComponent={PopoutComponent}
    />
  );
};

interface IPopoutMenuItemWithPopout {
  id: string;
  isOpen: boolean;
  buttonText: string;
  rootCustomCss?: CSSObject;
  position: IAbsolutePosition;
  PopoutComponent: ReactElement;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

PopoutSectionItemWithPopout.displayName = "PopoutSectionItemWithPopout";
export { PopoutSectionItemWithPopout };
